import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import DocumentIcon from "../../../components/Icons/DocumentIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import moment from "moment";
import { Table } from "reactstrap";
import { formatAmount, parseAmount } from "../../../utility/CommonFunctions";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import ViewIcon from "../../../components/Icons/ViewIcon";
import CommonTable from "../../../components/comman/CommonTable";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import MainHeading from "../../../components/comman/MainHeading";

export default function WorkOrderDetail() {
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [workOrder, setWorkOrder] = useState({});
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    invoiceList: [],
  });

  useEffect(() => {
    GetWorkOrderDetail();
    GetInvoiceList();
  }, []);

  const GetWorkOrderDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_work_order_detail + `?workorderId=${id}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setWorkOrder(response?.data);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    setModal(true);
  };

  const GetInvoiceList = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_invoice + "?" + `workorderId=${id}`;
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.invoice?.map((item) => ({
          ...item,
          inDate: moment(item?.invoiceDate).format("DD-MM-YYYY"),
          siteName: item?.workorder?.site?.name,
          taxableAmt: formatAmount(item?.taxableAmount),
          total: formatAmount(item?.totalAmount),
          tdsAmt: formatAmount(item?.tdsAmount),
          gstAmt: formatAmount(item?.totalAmount - item?.taxableAmount || 0),
          recievedAmt: formatAmount(item?.receivedAmount || 0),
          rententionAmt: formatAmount(item?.rententionAmount || 0),
          gstAmount: formatAmount(item?.totalAmount - item?.taxableAmount),
          grossAmount: formatAmount(item?.grossAmount),
          paymentDueAmt: formatAmount(item?.paymentDue),
          DueDays: item?.dueDays,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          invoiceList: newData,
        }));
      }
    });
  };

  const HandleView = (data) => {
    navigate(RoutesLink.invoice_detail + `/${data?.id}`);
  };

  const TableHeading = [
    { value: "invoiceNumber", label: "INV NO." },
    { value: "inDate", label: "Invoice Date" },
    { value: "siteName", label: "site " },
    { value: "DueDays", label: "Due Days" },
    { value: "taxableAmt", label: "Taxable Amount" },
    { value: "gstAmount", label: "GST Amount" },
    { value: "total", label: "Total Amount" },
    { value: "tdsAmt", label: "TDS Amount" },
    { value: "rententionAmt", label: "Retention Amount" },
    { value: "grossAmount", label: "Net Receivable" },
    { value: "recievedAmt", label: "Received Amount" },
    { value: "paymentDueAmt", label: "Payment Due" },
  ];

  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  return (
    <>
      {isLoading && <BgBlurLoader />}
      <div className="content container-fluid">
        <MainHeading title="Work Order Detail" showBackButton={true} />
        <div className="card manage-user-list">
          <div className="card-body">
            <ul
              className={
                isLoading
                  ? "row list-unstyled mt-4 loading-skeleton"
                  : "row list-unstyled mt-4"
              }
            >
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Work Order No. :-
                  </span>
                  {workOrder?.workOrderNumber || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">Title :-</span>
                  {workOrder?.title || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">Date :-</span>
                  {moment(workOrder?.date).format("DD-MM-YYYY") || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">Site :-</span>
                  {workOrder?.site?.name || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">Customer :-</span>
                  {workOrder?.site?.customer?.name || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Customer Company :-
                  </span>
                  {workOrder?.site?.customercompany?.companyName || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">GST Type :-</span>
                  {workOrder?.gstType || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Payment Term :-
                  </span>
                  {workOrder?.paymentTerms || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Last Billing :-
                  </span>
                  {workOrder?.lastBillingMonth || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-4">
                <p>
                  <span className="text-muted fs-5 d-block">Created By :-</span>
                  {workOrder?.user?.name || "--"}{" "}
                  {workOrder?.user?.designation?.name && (
                    <span className="text-muted fs-5">
                      ({workOrder?.user?.designation?.name} -{" "}
                      {workOrder?.user?.department?.name})
                    </span>
                  )}
                </p>
              </li>
              <li className="col-12">
                <p>
                  <span className="text-muted fs-5 d-block">Remark :-</span>
                  {workOrder?.remark || "--"}
                </p>
              </li>

              <div className="py-3 mb-4">
                <div className="d-flex align-items-center mb-2">
                  <h5 className="fw-semibold mb-0">Time Period</h5>
                  <div className="flex-grow-1 ms-3" style={{ height: 2, background: "#e5e7eb" }} />
                </div>

                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <div>
                    <small className="text-muted">Start Date</small>
                    <div className="fw-semibold">
                      {workOrder?.startDate
                        ? moment(workOrder.startDate).format("DD MMM YYYY")
                        : "--"}
                    </div>
                  </div>

                  <div className="fw-bold text-muted mt-3">→</div>

                  <div>
                    <small className="text-muted">End Date</small>
                    <div className="fw-semibold">
                      {workOrder?.endDate
                        ? moment(workOrder.endDate).format("DD MMM YYYY")
                        : "--"}
                    </div>
                  </div>
                </div>
              </div>

            </ul>
          </div>
        </div>
        <div className="row">
          <div className="card py-3">
            <Table bordered striped responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Item</th>
                  <th>HSN Code</th>
                  <th>Quantity</th>
                  <th>Unit</th>
                  <th>Rate</th>
                  <th>Taxable Amount</th>
                  {workOrder?.gstType === "IGST" && <th>IGST</th>}
                  {workOrder?.gstType === "CGST + SGST" && <th>CGST</th>}
                  {workOrder?.gstType === "CGST + SGST" && <th>SGST</th>}
                  <th>Total Amount</th>
                </tr>
              </thead>

              <tbody>
                {workOrder?.workorderitems?.length > 0 ? (
                  [...workOrder?.workorderitems]
                    ?.sort((a, b) => a?.item.localeCompare(b?.item))
                    ?.map((item, index) => {
                      const gstAmount = (item?.totalAmount * item?.gst) / 100;
                      const halfGst = gstAmount / 2;
                      return (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item?.item}</td>
                          <td>{item?.hsnCode}</td>
                          <td>{item?.quantity}</td>
                          <td>{item?.unit}</td>
                          <td>{formatAmount(item?.rate)}</td>
                          <td>{formatAmount(item?.totalAmount)}</td>

                          {workOrder?.gstType === "IGST" && (
                            <td>{`${formatAmount(gstAmount)} (${item?.gst
                              }%)`}</td>
                          )}

                          {workOrder?.gstType === "CGST + SGST" && (
                            <>
                              <td>{`${formatAmount(halfGst)} (${item?.gst / 2
                                }%)`}</td>
                              <td>{`${formatAmount(halfGst)} (${item?.gst / 2
                                }%)`}</td>
                            </>
                          )}

                          <td>{formatAmount(item?.taxableAmount)}</td>
                        </tr>
                      );
                    })
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
              {workOrder?.workorderitems?.length > 0 && (
                <tfoot>
                  <tr className="fw-bold bg-light">
                    <td colSpan={6} className="text-start">
                      Total :
                    </td>

                    <td>{formatAmount(workOrder?.taxableAmount)}</td>

                    {workOrder?.gstType === "IGST" && (
                      <td>
                        {formatAmount(
                          workOrder?.totalAmount - workOrder?.taxableAmount
                        )}
                      </td>
                    )}

                    {workOrder?.gstType === "CGST + SGST" && (
                      <>
                        <td>
                          {formatAmount(
                            (workOrder?.totalAmount -
                              workOrder?.taxableAmount) /
                            2
                          )}
                        </td>
                        <td>{formatAmount(workOrder?.totalAmount)}</td>
                      </>
                    )}

                    <td>{formatAmount(workOrder?.totalAmount)}</td>
                  </tr>
                </tfoot>
              )}
            </Table>
          </div>
        </div>

        <div className="row">
          <div className="card manage-user-list">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                <h4 className="d-flex align-items-center mb-4">Documents</h4>
              </div>
              <ul className="row list-unstyled gap-3">
                {workOrder?.documents?.length > 0 ? (
                  workOrder?.documents?.map((doc, index) => {
                    return (
                      <li key={index} className="col-12">
                        <div
                          className="text-muted fs-5 d-flex align-items-center justify-content-between text-decoration-none w-100"
                          onClick={() => handleDocumentClick(doc)}
                          role="button"
                        >
                          <span className="d-flex align-items-center gap-2">
                            <DocumentIcon />
                            {doc?.name || "Document"}
                          </span>
                          <span className="fs-6">
                            {doc?.updatedAt ? moment(doc?.updatedAt).format("DD MMM YYYY | h:mm a") : ""}
                          </span>
                        </div>
                      </li>
                    );
                  })
                ) : (
                  <div>No Document Found</div>
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
          <h4 className="d-flex align-items-center mb-4">Invoice List</h4>
        </div>

        {pageStates?.invoiceList?.length > 0 && (
          <div className="d-flex gap-3 mb-4 overflow-auto flex-nowrap">
            {[
              { label: "Total TDS", value: pageStates.invoiceList.reduce((a, i) => a + +i.tdsAmount, 0) },
              { label: "Retention", value: pageStates.invoiceList.reduce((a, i) => a + +i.rententionAmount, 0) },
              { label: "Invoice Amount", value: pageStates.invoiceList.reduce((a, i) => a + +i.totalAmount, 0) },
              { label: "Received", value: pageStates.invoiceList.reduce((a, i) => a + +i.receivedAmount, 0) },
              { label: "Net Receivable", value: pageStates.invoiceList.reduce((a, i) => a + parseAmount(i.grossAmount), 0) },
              { label: "Payment Due", value: pageStates.invoiceList.reduce((a, i) => a + parseAmount(i.paymentDue), 0) },
            ].map((item, index) => (
              <div key={index} style={{ minWidth: "220px" }}>
                <div className="card shadow-sm">
                  <div className="card-body py-2 px-3">
                    <small className="text-muted">{item.label}</small>
                    <div className="fw-bold">{formatAmount(item.value)}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <CommonTable
          TableHeading={TableHeading}
          TableData={pageStates?.invoiceList}
          ActionData={ActionData}
          isLoading={pageStates?.tableLoader}
        />


      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
